function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "security",
  transform: "translate(-4.5 -2.25)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11860",
  "data-name": "Path 11860",
  d: "M25.417,34.59l-9.174-9.174L11.25,30.41,25.417,44.576,53.75,16.243,48.757,11.25Z",
  transform: "translate(14.5 19.333)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11861",
  "data-name": "Path 11861",
  d: "M47,101.417,25.127,89.753A38.9,38.9,0,0,1,4.5,55.375V9.333A7.09,7.09,0,0,1,11.583,2.25H82.417A7.09,7.09,0,0,1,89.5,9.333V55.375A38.9,38.9,0,0,1,68.873,89.753ZM11.583,9.333V55.375A31.821,31.821,0,0,0,28.464,83.5L47,93.389l18.536-9.882a31.821,31.821,0,0,0,16.88-28.132V9.333Z",
  transform: "translate(0)"
}));

var SvgSecurity2 = function SvgSecurity2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 99.167,
    viewBox: "0 0 85 99.167",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecurity2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/security2.b11fb588.svg";
export { ForwardRef as ReactComponent };